// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { FC, useEffect, useState } from 'react';
import { MantineTheme, Skeleton, Text } from '@mantine/core';
import { useNavigate, useParams } from 'react-router-dom';
import { CreateContractConfigDTO, ProcedureReportProps } from '../../../../Types/LogT';
import { fetchContractTemplate } from '../../../../Service/restapi/contractService';
import LinkText from '../../../../Atoms/LinkText';
import { WorkflowS } from '../../../../Service/WorkflowS';
import { getReportExecutionState } from './reportExecutionState';

const CreateContractReport: FC<ProcedureReportProps> = ({ report, config, disableLinks = false }) => {
  const { templateId } = config as CreateContractConfigDTO;
  const { entityId, executionStatus } = report ?? {};
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState<any>();
  const executionState = getReportExecutionState(executionStatus);
  const contractCreated = executionState === 'COMPLETED';
  const linkColor = (theme: MantineTheme) =>
    contractCreated ? (theme.colorScheme === 'dark' ? theme.colors.blue[1] : theme.colors.blue[4]) : 'inherit';

  const onClick = () => {
    if (eventId && contractCreated) {
      navigate(`/events/${eventId}/contracts/${entityId}`);
    }
  };

  useEffect(() => {
    if (templateId) {
      setLoading(true);
      fetchContractTemplate(templateId)
        .then((resJSON) => {
          if (resJSON) {
            setTemplate(resJSON);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [templateId]);

  return (
    <Text>
      {executionState === 'SKIPPED' ? (
        <>
          Erstellung des <Text span weight="bolder">Vertrags</Text>
        </>
      ) : (
        <Text
          span
          weight="bolder"
          onClick={onClick}
          variant={contractCreated ? 'link' : 'text'}
          sx={(theme) => ({
            cursor: contractCreated ? 'pointer' : 'default',
            pointerEvents: disableLinks ? 'none' : undefined,
            color: linkColor(theme),
          })}
        >
          Vertrag
        </Text>
      )}{' '}
      {executionState === 'COMPLETED' && 'wurde aus Vorlage'}
      {executionState === 'PLANNED' && 'wird aus Vorlage'}
      {executionState === 'SKIPPED' && 'aus Vorlage'}
      {executionState === 'NOT_EXECUTED' && 'wurde nicht aus Vorlage'}
      {' '}
      {loading || !template ? (
        <Skeleton mb={-3} height={16} width={100} sx={{ display: 'inline-block' }} />
      ) : (
        <LinkText
          span
          disabled={disableLinks}
          weight="bolder"
          onClick={() => navigate(`/settings/template/contract/${template.name}`)}
        >
          {template.name}
        </LinkText>
      )}{' '}
      {executionState === 'SKIPPED' ? 'übersprungen.' : 'erstellt.'}
      {WorkflowS.getWorkflowErrorDescription(report)}
    </Text>
  );
};

export default CreateContractReport;
